import React from 'react';
import PageHeader from '@/portal/components/PageHeader.tsx';
import { Container } from 'react-bootstrap';
import EhrIntegrationSettingsBlock from './components/EhrIntegrationSettingsBlock.tsx';
import NotificationSettingsBlock from './components/NotificationSettingsBlock.tsx';

const SettingsPage: React.FC = () => {
  return (
    <>
      <PageHeader title="Settings" />
      <Container className="py-4">
        <div className="row">
          <div className="col-12">
            <EhrIntegrationSettingsBlock />
          </div>
        </div>

        <div className="row mt-4">
          <div className="col-12">
            <NotificationSettingsBlock />
          </div>
        </div>
      </Container>
    </>
  );
};

export default SettingsPage;
